import MuiAlert from "@mui/material/Alert";
import type { AlertProps } from "@mui/material/Alert";
import { InfoIcon } from "../../shared/icons";

export const Alert = ({ children }: AlertProps) => {
  return (
    <MuiAlert
      sx={theme => ({
        borderRadius: 1,
        color: theme.palette.info.dark,
        backgroundColor: theme.palette.info["50"],
        alignItems: "center",
        fontSize: theme.typography.pxToRem(14),
        border: `1px solid ${theme.palette.info["100"]}`,
      })}
      severity="info"
      iconMapping={{
        info: <InfoIcon size={16} color={theme => theme.palette.info.main} />,
      }}
    >
      {children}
    </MuiAlert>
  );
};
